/**
 * A short buzz confirms start/stop without the student looking at the screen
 * (docs/UX.md §1.3). Silently does nothing where unsupported (iOS Safari)
 * or when the reader asked for reduced motion.
 */
export function buzz(ms = 12): void {
  try {
    if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    navigator.vibrate(ms);
  } catch {
    /* ignore */
  }
}
